import isEmpty from '../helpers/isEmpty'
//---------------------------
// capitalise multiple words
//---------------------------
export default function capitaliseMultipleWords(str) {
  // console.log("----------------------");
  // console.log("IN capitaliseMultipleWords = " + str);
  let return_str = ''

  if (!isEmpty(str)) {
    return_str = String(str).replace(
      /(^|[\s\-_'([{])([a-z])/g,
      (match, prefix, letter) => `${prefix}${letter.toUpperCase()}`,
    )
  }
  return return_str
}
